import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let VehicleMode = class VehicleMode extends Vue {
    value;
    disabled;
    modeData = [
        {
            name: `${this.$t('licensePlate')}`,
            value: 'LICENSE_PLATE_ATTRIBUTE',
        },
        {
            name: `${this.$t('vehicleAttribute')}`,
            value: 'VEHICLE_FEATURE',
        },
    ];
    get vehicleValue() {
        return this.value;
    }
    set vehicleValue(val) {
        this.$emit('input', val);
    }
};
__decorate([
    Prop()
], VehicleMode.prototype, "value", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], VehicleMode.prototype, "disabled", void 0);
VehicleMode = __decorate([
    Component({
        name: 'VehicleMode',
        components: {},
        i18n: {
            messages: {
                zh: {
                    licensePlate: '车牌布控',
                    vehicleAttribute: '车辆属性布控',
                    title: '布控方式',
                },
                en: {
                    licensePlate: 'License Plate',
                    vehicleAttribute: 'Vehicle Attribute',
                    title: 'Mode',
                },
            },
        },
    })
], VehicleMode);
export default VehicleMode;
